<template lang="pug">
	vue-good-table(
		mode="remote"
		:pagination-options='{enabled: true, perPage: perPage}'
		:columns="_columns"
		:rows='rows'
		:totalRows='totalRows'
		:isLoading.sync="isLoading"
		:expandedOptions='{key: expandId, expandedRows: expandedRows }'
		@on-page-change='onPageChange'
		@on-sort-change="onSortChange")
		template(slot='emptystate')
			slot(name='emptystate')
		template(slot='table-row' slot-scope='props')
			span(v-if='props.column.field==="_expand"')
				.btn.btn-sm.btn-circle.text-white(type='button' v-bind:class='{"bg-success": !expandedRows.includes(props.row.id), "bg-danger": expandedRows.includes(props.row.id)}' @click.preven='toggleExpand(props.row.id)')
					i.m-0.fa(v-bind:class='{"fa-plus": !expandedRows.includes(props.row.id), "fa-minus": expandedRows.includes(props.row.id)}')
			template(v-else)
				slot(name='row' v-bind='props')
		template(slot='expanded-row' slot-scope='props')
			slot(name='expand' v-bind='props')
</template>

<script>
export default {
	props: {
		perPage: {
			default: 10
		},
		columns: {
			default() {
				return []
			}
		},
		expandId: {
			default: 'id'
		},
		expand: {
			default: false
		},
		filter: {
			default() {
				return {}
			}
		},
		sort: {
			default() {
				return []
			}
		},
		client: {
			default() {
				return Promise.resolve({rows: [], totalRows: 0})
			}
		}
	},

	name: 'server-table',

	data () {
		return {
			rows: [],
			totalRows: 0,
			isLoading: true,

			expandedRows: [],
			serverParams: {
				filter: this.filter,
				sorts: this.sort,
				currentPage: 1,
				perPage: this.perPage
			}
		}
	},

	mounted() {
		this.load()
	},

	computed: {
		/**
		 * [_columns description]
		 * @return {[type]} [description]
		 */
		_columns() {
			if(this.expand!==false||this.expand==='') {
				return [{field: "_expand", label: "", tdClass: "text-center", sortable:false}].concat(this.columns)
			}
			return this.columns
		}
	},

	methods: {
		/**
		 * [load_with_filters description]
		 * @param  {[type]} filter [description]
		 * @return {[type]}        [description]
		 */
		load_with_filters(filter) {
			this.serverParams.filter=filter
			this.load()
		},

		/**
		 * [toggleExpand description]
		 * @param  {[type]} id [description]
		 * @return {[type]}    [description]
		 */
		toggleExpand(id) {
  		if(this.expandedRows.includes(id)) {
  			this.expandedRows=[]
  		} else {
  			this.expandedRows = [id]
  		}
  	},

		/**
		 * [onSortChange description]
		 * @param  {[type]} params [description]
		 * @return {[type]}        [description]
		 */
		onSortChange(params) {
			// console.log(params)
			this.serverParams.sorts=params
			this.load()
		},

		/**
		 * [onPageChange description]
		 * @param  {[type]} param [description]
		 * @return {[type]}       [description]
		 */
		onPageChange(param) {
			// console.log(param)
			this.serverParams.currentPage=param.currentPage;
			this.serverParams.perPage=param.currentPerPage;
			this.load(true)
		},

		/**
		 * [load description]
		 * @return {[type]} [description]
		 */
		load(has_page=false) {
			// console.log('Reload table')
			if(!has_page) {
				this.serverParams.currentPage=1
			}
			this.isLoading=true
			this.client(this.serverParams)
				.then(data => {
					this.rows=data.rows||[]
					this.totalRows=data.totalRecords||0
				})
				.finally(() => {
					this.isLoading=false
					$('[data-toggle="tooltip"]').tooltip()
				})
		}
	}
}
</script>

<style lang="css" scoped>
</style>